module.exports = __webpack_public_path__ + "static/media/checkbox.81d34452.svg";